export const FrameworksTableData = {
    rows: [
        {
            title: 'BCBS 239 Principles for effective risk data aggregation and risk reporting',
            id: 1,
        },
        { title: 'Group Data Governance Framework', id: 2 },
        { title: 'Group Data Lifecycle Management Operating Standard', id: 3 },
        { title: 'Group Data Quality Management Operating Standard', id: 4 },
        { title: 'Group Master and Reference Data Management Standard', id: 5 },
        { title: 'Group Risk Management Framework', id: 6 },
        { title: 'Group Metadata Management Operating Standard', id: 7 },
        { title: 'Information Risk Policy', id: 8 },
        { title: 'Group Business Resilience Framework', id: 9 },
        { title: 'Group Data Privacy Operating Standard', id: 10 },
        { title: 'Group Model Risk Governance Framework', id: 11 },
        { title: 'Non-Financial Risk Governance Framework', id: 12 },
        { title: 'New Product Committee RDARR Checklist', id: 13 },
        { title: 'Risk Appetite Framework', id: 14 },
    ],
    total: 14,
};

export const FrameworksTableColumns = [
    {
        displayName: 'This document should be read in conjunction with the following documents:',
        sortColumnName: 'title',
        dataType: 'string',
        dataKey: 'title',
        settings: { sort: true, filter: false, multiple: false },
        css: 'pad-end',
    },
];

export const FrameworkSortingConfig = {
    sortByColumn: 'title',
    sortByDescending: false,
    callback: () => {},
};

export const FrameworksPaginationConfig = {
    paginationEvent: () => {},
    paginationData: {
        pageNumber: 1,
        pageSize: 5,
        total: FrameworksTableData.total,
    },
    defaultPageSize: {
        value: 5,
        text: '5',
    },
};
